import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend, Title);

// const generateColors = (count) => {
//   return Array.from({ length: count }, () => {
//     const randomColor = `#${Math.floor(Math.random() * 16777215).toString(16)}`;
//     return randomColor;
//   });
// };
const generateColors = (count) => {
  const mandatoryColors = ['#69C195', '#F97066', '#98A2B3', '#84BFF3', '#FDB022'];
  if (count <= mandatoryColors.length) return mandatoryColors.slice(0, count);
  return [
    ...mandatoryColors,
    ...Array.from({ length: count - mandatoryColors.length }, () => `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')}`)
  ];
};
const PieChart = ({ chartData }) => {

  // Extracting labels and values dynamically
  const labels = Object.keys(chartData?.byProviderType || {}).map(
    (key) => `${key} ${chartData.byProviderType[key] || 0}`
  );
  const values = Object.values(chartData?.byProviderType || {}).map(
    (val) => Number(val) || 0
  );
  const backgroundColors = generateColors(labels.length);
  const data = {
    labels,
    datasets: [
      {
        label: "Provider Types",
        data: values,
        backgroundColor: backgroundColors,
        hoverOffset: 4,
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "right",
        labels: {
          boxWidth: 10,
          padding: 20,
          usePointStyle: true,
        },
      },
    },
    cutout: "60%",
  };

  // Custom plugin for center text
  const centerTextPlugin = {
    id: "centerText",
    beforeDraw: (chart) => {
      const {
        ctx,
        data,
        chartArea: { width, height },
      } = chart;
      ctx.save();
      const total = data.datasets[0].data.reduce(
        (acc, value) => acc + Number(value),
        0
      );

      ctx.font = "bold 20px Arial";
      ctx.fillStyle = "#1D2939";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(`${total}`, width / 2, height / 2 - 10);

      ctx.font = "13px Arial";
      ctx.fillText("Total Workers", width / 2, height / 2 + 10);
      ctx.restore();
    },
  };

  return (
    <div className="card-body mt-3.5" style={{width: "360px"}}>
      <Doughnut data={data} options={options} plugins={[centerTextPlugin]} />
    </div>
  );
};

export default PieChart;
